import { Component } from "@angular/core";
import { IxModule } from "@siemens/ix-angular";

@Component({
  selector: "app-spinner-large",
  imports: [IxModule],
  styles: `
    :host {
      display: contents;
    }
  `,
  template: `<ix-spinner size="large" />`,
})
export class SpinnerLargeComponent {}
